export interface EuropeanLocale {
  value: string;
  label: string;
}

export const DEFAULT_ARTICLE_LOCALE = "fr_FR";

export const EUROPEAN_LOCALES: EuropeanLocale[] = [
  { value: "sq_AL", label: "Albanais — Albanie" },
  { value: "ca_AD", label: "Catalan — Andorre" },
  { value: "de_DE", label: "Allemand — Allemagne" },
  { value: "de_AT", label: "Allemand — Autriche" },
  { value: "de_CH", label: "Allemand — Suisse" },
  { value: "en_GB", label: "Anglais — Royaume-Uni" },
  { value: "en_IE", label: "Anglais — Irlande" },
  { value: "hy_AM", label: "Arménien — Arménie" },
  { value: "az_AZ", label: "Azéri — Azerbaïdjan" },
  { value: "be_BY", label: "Biélorusse — Biélorussie" },
  { value: "bs_BA", label: "Bosnien — Bosnie-Herzégovine" },
  { value: "bg_BG", label: "Bulgare — Bulgarie" },
  { value: "ca_ES", label: "Catalan — Espagne" },
  { value: "hr_HR", label: "Croate — Croatie" },
  { value: "da_DK", label: "Danois — Danemark" },
  { value: "es_ES", label: "Espagnol — Espagne" },
  { value: "et_EE", label: "Estonien — Estonie" },
  { value: "fi_FI", label: "Finnois — Finlande" },
  { value: "fr_FR", label: "Français — France" },
  { value: "fr_BE", label: "Français — Belgique" },
  { value: "fr_CH", label: "Français — Suisse" },
  { value: "el_GR", label: "Grec — Grèce" },
  { value: "el_CY", label: "Grec — Chypre" },
  { value: "hu_HU", label: "Hongrois — Hongrie" },
  { value: "ga_IE", label: "Irlandais — Irlande" },
  { value: "is_IS", label: "Islandais — Islande" },
  { value: "it_IT", label: "Italien — Italie" },
  { value: "it_SM", label: "Italien — Saint-Marin" },
  { value: "it_VA", label: "Italien — Vatican" },
  { value: "ka_GE", label: "Géorgien — Géorgie" },
  { value: "lv_LV", label: "Letton — Lettonie" },
  { value: "lt_LT", label: "Lituanien — Lituanie" },
  { value: "lb_LU", label: "Luxembourgeois — Luxembourg" },
  { value: "mk_MK", label: "Macédonien — Macédoine du Nord" },
  { value: "mt_MT", label: "Maltais — Malte" },
  { value: "fr_MC", label: "Français — Monaco" },
  { value: "nl_NL", label: "Néerlandais — Pays-Bas" },
  { value: "nl_BE", label: "Néerlandais — Belgique" },
  { value: "nb_NO", label: "Norvégien — Norvège" },
  { value: "pl_PL", label: "Polonais — Pologne" },
  { value: "pt_PT", label: "Portugais — Portugal" },
  { value: "ro_RO", label: "Roumain — Roumanie" },
  { value: "ro_MD", label: "Roumain — Moldavie" },
  { value: "ru_RU", label: "Russe — Russie" },
  { value: "sr_RS", label: "Serbe — Serbie" },
  { value: "sr_ME", label: "Serbe — Monténégro" },
  { value: "sk_SK", label: "Slovaque — Slovaquie" },
  { value: "sl_SI", label: "Slovène — Slovénie" },
  { value: "sv_SE", label: "Suédois — Suède" },
  { value: "cs_CZ", label: "Tchèque — Tchéquie" },
  { value: "tr_TR", label: "Turc — Turquie" },
  { value: "uk_UA", label: "Ukrainien — Ukraine" }
];

const EUROPEAN_LOCALE_VALUES = new Set(EUROPEAN_LOCALES.map((locale) => locale.value));

export function isEuropeanLocale(value: string): boolean {
  return EUROPEAN_LOCALE_VALUES.has(value);
}

export function localeToHtmlLanguage(locale: string): string {
  return locale.replace("_", "-");
}
